import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.css'],
    standalone: false
})
export class AlertDialogComponent implements OnInit {

  // alertTitle!:string;
  // alertMessage!:string;
  // alertType!:string;

  constructor(@Inject(MAT_DIALOG_DATA) public alertData :any) { }

  ngOnInit(): void {
  }

  refreshPage(){
    window.location.reload();
  }

  closeDialog(){
    window.location.reload();
  }


}
